/**
 * Page-level header with icon, title, subtitle, and action slots.
 * Renders with no padding by default — let the parent container control spacing.
 *
 * @example
 * import { IconHighlight } from '@aimsos/ui';
 * import { Shield } from 'lucide-react';
 * import { Button } from '@aimsos/ui';
 *
 * <PageHeader
 *   icon={<IconHighlight icon={Shield} bgColor="Primary" iconColor="PrimaryAlt" size="medium" />}
 *   title="Truth Plane"
 *   subtitle="5 knowledge bases"
 *   actions={<Button>+ New</Button>}
 * />
 */
const PageHeader = ({
  icon,
  title,
  subtitle,
  actions,
  className = '',
  ...props
}) => (
  <div
    className={['flex items-center justify-between gap-3', className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    <div className="flex min-w-0 flex-1 items-center gap-3">
      {icon && <div className="shrink-0">{icon}</div>}
      <div className="min-w-0">
        <h1 className="truncate text-xl font-bold text-content">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-content-muted">{subtitle}</p>}
      </div>
    </div>

    {actions && (
      <div className="flex shrink-0 items-center gap-2">{actions}</div>
    )}
  </div>
);

export default PageHeader;
